export default function(cb: (...args: any[]) => any) {
  return (...args: any[]) => {
    if (process.env.NODE_ENV === "development") {
      return cb.apply(this, args);
    }
  };
}
